export const APP_VERSION = '1.0.0';
export const API_PREFIX = `${process.env.REACT_APP_API_SERVER_URL}`;
export const ENABLE_REDUX_LOGGER = false;
export const MAINTENANCE_MODE =
  String(process.env.REACT_APP_MAINTENANCE_MODE).toLowerCase() === 'true';
